import { IGoodReceive } from '@/interfaces/goodReceive';
import { formatThaiDate } from '@/utils/dataUtils';
import React from 'react';

interface IProps {
  data?: IGoodReceive;
}

const TemplateGrnFooter = ({ data }: IProps) => {
  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        padding: '30px',
      }}
    >
      <div className="grid grid-cols-8 gap-4">
        <div className="col-start-2 col-span-6">
          <div className="grid grid-cols-3 items-center text-sm font-bold gap-1">
            <div className="flex flex-col gap-2">
              <p className="text-center">ผู้รับของ</p>
              <div className="h-24 grid grid-cols-1 gap-4 content-end border border-black p-2 items-center">
                <div className="text-center flex flex-col gap-2">
                  <div className="border-b border-black">
                    {data?.receivedBy}
                  </div>
                  <div className="flex flex-row border-b border-black text-left text-xs justify-between">
                    <div>วันที่</div>
                    <div>{formatThaiDate(data?.grDate)}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-center">ผู้ตรวจสอบ</p>
              <div className="h-24 grid grid-cols-1 gap-4 content-end border border-black p-2 items-center">
                <div className="text-center flex flex-col gap-2">
                  <div className="border-b border-black">
                    {data?.verifiedBy}
                  </div>
                  <div className="flex flex-row border-b border-black text-left text-xs justify-between">
                    <div>วันที่</div>
                    <div>{formatThaiDate(data?.grDate)}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-center">ผู้อนุมัติ</p>
              <div className="h-24 grid grid-cols-1 gap-4 content-end border border-black p-2 items-center">
                <div className="text-center flex flex-col gap-2">
                  <div className="border-b border-black"></div>
                  <div className="flex flex-row border-b border-black text-left text-xs justify-between">
                    <div className="absolute top-[60px] right-[170px] max-w-[80px]">
                      <img
                        src="/pioneerSignature.png"
                        alt="pioneerSignature"
                        style={{ maxHeight: 100 }}
                      />
                    </div>
                    <div className="absolute top-[20px] right-[100px] max-w-[100px]">
                      <img
                        src="/pioneerStamp.png"
                        alt="pioneerStamp"
                        style={{ maxHeight: 100 }}
                      />
                    </div>
                    <div>วันที่</div>
                    <div>{formatThaiDate(data?.grDate)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateGrnFooter;
